

require("jquery");
require("angularPlaceHolderShim");
require("js/lib/index");
require("xo-tracking/dist/index");
var _middleware = require("js/lib/middleware");
define(['angular', 'squid/index', 'pages/xo-generic-error/route', 'xo-guest-components/src/guest-upgrade/directive'], function (angular, squid) {
  (function exportProviders(angular) {
    angular && angular.exportProviders(module, exports, __dirname, __filename);
  })(window.angular);
  angular.module('hermes.page.xo-guest-upgrade.route', ['squid', 'hermes.page.xo-generic-error.route', 'xo-guest-upgrade.directive']).factory('$GuestUpgradeRoute', function ($ComponentRoute) {
    return $ComponentRoute.extend('GuestUpgradeRoute', {
      defaultState: 'guestupgrade',
      middleware: _middleware.$Middleware,
      name: 'guestupgrade',
      directive: 'xo-guest-upgrade',
      // Uncomment the following line to suffix content to
      // the title of the page
      // Base title is 'PayPal Checkout'
      // titleContent: 'accountCreationGuest.heading',

      trackingData: {
        templateName: 'xoguestupgrade.dust',
        pageGoal: 'guest upgrade',
        pageQualifier: 'guestupgrade',
        buzname: {
          'guestupgrade': {
            'pagename': '%::guestupgrade',
            'pagename2': '%::guestupgrade:prox-guest-upgrade',
            'version': 'version-1:%:'
          }
        }
      },
      children: [{
        name: '$GenericErrorRoute'
      }]
    });
  });
});
_middleware.$Middleware;


//////////////////
// WEBPACK FOOTER
// ./pages/xo-guest-upgrade/route.js
// module id = ./pages/xo-guest-upgrade/route.js
// module chunks = 0